import { takeEvery } from '@pressreader/appstore';
import { ArticleFields } from '@pressreader/content-types';
import { error } from '@pressreader/logger';
import { closeContextMenu, openContextMenu, takeCloseContextMenuRequest } from '@pressreader/popups-legacy';

import { ArticleBaseContextMenuContext, ArticleContextMenuName } from '../../types';
import { openPrintMenuAction } from '../actions';
import { getMenuPositionFromPoint, loadArticleById } from '../saga.utils';

function* openPrintMenu({ payload }: ReturnType<typeof openPrintMenuAction>) {
    try {
        const position = getMenuPositionFromPoint(payload.center);

        const { articleId } = payload;
        yield* loadArticleById(articleId, {
            requiredFields: ArticleFields.Issue | ArticleFields.Publication | ArticleFields.Images,
            force: false,
            lang: payload.article?.language,
        });

        const ctxMenuId = yield* openContextMenu<ArticleBaseContextMenuContext>({
            parentMenuId: payload.parentMenuId,
            name: ArticleContextMenuName.ArticlePrintContextMenu,
            context: { articleId },
            position,
        });

        const {
            payload: { back },
        } = yield* takeCloseContextMenuRequest(ctxMenuId);

        yield* closeContextMenu(ctxMenuId, { back });
    } catch (e) {
        error(e);
    }
}

export function* saga() {
    yield takeEvery(openPrintMenuAction, openPrintMenu);
}
